import { render, staticRenderFns } from "./CustomizationSettingsPage.vue?vue&type=template&id=368ae0ba&"
import script from "./CustomizationSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./CustomizationSettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports